export default __webpack_public_path__ + "static/media/1868.68ebbaad.png";